// extracted by mini-css-extract-plugin
module.exports = {"mrv1iol":"mrv1iol","mv0p2zg":"mv0p2zg","m1w4qu9f":"m1w4qu9f","m1odb2jl":"m1odb2jl"};